import gql from 'graphql-tag';

import { executeGqlMutation } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';
import type {
  BackendMutationDeleteProjectFolderArgs,
  BackendProjectFolder,
} from 'src/types/backend';

const MUTATION = gql`
  mutation DeleteProjectFolder($id: ID!, $userApproved: Boolean!) {
    deleteProjectFolder(id: $id, userApproved: $userApproved) {
      id
    }
  }
`;

type Variables = BackendMutationDeleteProjectFolderArgs;
type Result = Pick<BackendProjectFolder, 'id'>;

export const deleteProjectFolder = async (variables: Variables) => {
  const result = await executeGqlMutation({ mutation: MUTATION, variables });
  return getSingleProp<Result>(result.data);
};
